import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn"; // Icon for indicating zoom

const ImageComponent = ({ imageUrl, altText }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        component="div"
        sx={{
          position: "relative",
          cursor: "pointer",
          "&:hover .overlay": {
            opacity: 1,
          },
        }}
        onClick={handleClickOpen}
      >
        <Box
          component="img"
          src={imageUrl || "https://via.placeholder.com/1100x500"}
          alt={altText || "Band Image"}
          sx={{
            width: "100%",
            objectFit: "cover",
            mb: 3,
            height: { xs: "200px", sm: "400px" },
          }}
        />
        {/* Overlay with indication to click */}
        <Box
          className="overlay"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            opacity: 0,
            transition: "opacity 0.3s",
          }}
        >
          <Typography variant="h6">Click to view full image</Typography>
          <IconButton>
            <ZoomInIcon sx={{ color: "#fff", ml: 1 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Dialog for full image */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <DialogContent sx={{ p: 0 }}>
          <Box
            component="img"
            src={imageUrl || "https://via.placeholder.com/1100x500"}
            alt={altText || "Band Image"}
            sx={{
              width: "100%",
              height: "auto",
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageComponent;
